import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Adcan_Pharma_Abu_dhabi.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>ADCAN Pharma</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A pharmaceutical manufacturing and storage facility in Abu Dhabi operated by ADCAN — a leading name in the UAE
                  pharmaceutical sector. MEP works were delivered to meet the stringent technical and hygiene specifications required by
                  GMP-standard pharma facilities.</p>
              <p>MAIN CONTRACTOR : ALEC</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : CHW, hot water and electrical works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one